// Deploy builds set REACT_APP_API_ENDPOINT from SSM (scripts/build-for-env.sh).
// These URLs are only fallbacks for local runs.
const dev = {
  API_ENDPOINT: "https://8kxzmynoae.execute-api.us-east-1.amazonaws.com"
};

const prod = {
  API_ENDPOINT: "https://iypj3vpe38.execute-api.us-east-1.amazonaws.com"
};

const config = process.env.REACT_APP_ENV === 'prod'
  ? prod
  : dev;

const endpointOverride = process.env.REACT_APP_API_ENDPOINT;

export default {
  IMAGE_UPLOAD_SUPPORT: false,
  ...config,
  ...(endpointOverride ? { API_ENDPOINT: endpointOverride } : {})
};